import { Module } from 'vuex';
import { RootState } from '../store';
import { mutations } from '../mutations/upload-video.mutations';
import { actions } from '../actions/upload-video.actions';

export const namespace = 'uploadVideo';

export interface UploadVideoState {
  isUploading: boolean;
  videoStatus: string;
  recordVideo: boolean;
  documentId: string;
  videoId: string;
  videoStreamStatus: boolean;
}

export const state: UploadVideoState = {
  isUploading: false,
  videoStatus: '',
  recordVideo: false,
  documentId: '',
  videoId: '',
  videoStreamStatus: false,
};

const namespaced: boolean = true;

export const uploadVideo: Module<UploadVideoState, RootState> = {
  actions,
  namespaced,
  mutations,
  state,
};
